import React from 'react'
import { CheckoutPriceCardBase } from './BaseComponent'
import { Categories } from '@/enums'

// Define types that match what's expected by BaseComponent
type PaymentPeriod = 'monthly' | 'yearly'
type CategoryId = keyof typeof Categories

interface ProductData {
  grossPrice: number
  originalGrossPrice?: number
  paymentPeriod: PaymentPeriod
  insuranceProductId: string
  carrierData: {
    logoUrl: string
    name: string
  }
  categoryId: CategoryId
}

export interface CheckoutPriceCardProps {
  data?: ProductData[]
  hideProducts?: boolean
  buttonText?: string
  onButtonClick?: () => void
}

export const CheckoutPriceCard: React.FC<CheckoutPriceCardProps> = ({
  data = [],
  hideProducts,
  buttonText,
  onButtonClick,
}) => (
  <CheckoutPriceCardBase
    buttonText={buttonText}
    data={data}
    hideProducts={hideProducts}
    onButtonClick={onButtonClick}
  />
)
